// @flow

export const convertToCSV = (objArray: Object | string) => {
  const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray

  const lineReducer = item =>
    Object.keys(item).reduce((line, key) => {
      if (line !== '') line += ','
      return (line += item[key])
    }, '')

  const columReducer = (accumulator, item) => {
    const keys = lineReducer(item)
    return (accumulator += `${keys}\r\n`)
  }

  const str = array.reduce(columReducer, '')

  return str
}

export const downloadFile = (blob: Blob, filename: string) => {
  if (navigator.msSaveBlob) {
    // IE 10+
    // $FlowFixMe
    navigator.msSaveBlob(blob, filename)
  } else {
    const link = document.createElement('a')
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', filename)
      link.style.visibility = 'hidden'
      if (document.body) {
        document.body.appendChild(link)
      }
      link.click()
      if (document.body) {
        document.body.removeChild(link)
      }
    }
  }
}

export const exportCSVFile = (headers: Array<any>, item: Array<any>) => {
  if (headers) {
    item.unshift(headers)
  }
  // Convert Object to JSON
  const jsonObject = JSON.stringify(item)

  const csv = convertToCSV(jsonObject)

  const blob = new Blob([csv], { type: 'text/csvcharset=utf-8' })

  return blob
}



// WEBPACK FOOTER //
// ./src/util/index.js